var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReload = function SvgReload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "10 13 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "reload_svg__a_CC5TOSEI",
    d: "M0 0h44v44H0Z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(10 13)",
    d: "M12 0a9 9 0 0 0-9 9H0l3.89 3.89.07.14L8 9H5a7 7 0 1 1 7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.896 8.896 0 0 0 12 18a9 9 0 0 0 0-18Z",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgReload;